export const DISPATCH_ADMIN_DATA_UPDATE = 'DISPATCH_ADMIN_DATA_UPDATE';
export const DISPATCH_ADMIN_DATA_UPDATE_SUCCESS = 'DISPATCH_ADMIN_DATA_UPDATE_SUCCESS';
export const DISPATCH_ADMIN_DATA_UPDATE_FAILURE = 'DISPATCH_ADMIN_DATA_UPDATE_FAILURE';
export const CLEAR_ADMIN_DATA_UPDATE_STATUS = 'CLEAR_ADMIN_DATA_UPDATE_STATUS';